import config from '../config';

export const apiEvents = {
  // Лента мероприятий: фильтры — город, сортировка (new/date), конкретная дата
  fetchEvents: async (axiosPrivate, { page = 1, limit = 20, city, sort, date } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (city) params.set('city', city);
    if (sort) params.set('sort', sort);
    if (date) params.set('date', date);

    const response = await axiosPrivate.get(`${config.API.EVENTS.BASE}?${params.toString()}`);
    return response.data.data;
  },

  fetchEvent: async (axiosPrivate, eventId) => {
    const response = await axiosPrivate.get(config.API.EVENTS.BY_ID(eventId));
    return response.data.data;
  },

  // «Хочу пойти» / отмена участия (toggle)
  toggleJoin: async (axiosPrivate, eventId) => {
    const response = await axiosPrivate.post(config.API.EVENTS.JOIN(eventId));
    return response.data.data;
  },

  // Список тех, кто собирается пойти
  fetchJoins: async (axiosPrivate, eventId) => {
    const response = await axiosPrivate.get(config.API.EVENTS.JOINS(eventId));
    return response.data.data;
  },

  // Отправить приглашение в чат
  invite: async (axiosPrivate, eventId, chatId) => {
    const response = await axiosPrivate.post(config.API.EVENTS.INVITE(eventId), { chatId });
    return response.data.data;
  }
};
